import { confirm } from "devextreme/ui/dialog";
import { useContext } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { AR, FileTypes } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useApproveQuality } from "../api/approve-quality";
import { RetailOrderContext } from "../context/RetailOrderContext";
import { WorksheetType } from "../types/WorksheetType";
import RetailOrderFiles from "./RetailOrderFiles";
import WorksheetTemplateLink from "./WorksheetTemplateLink";

export default function QualityCheckFiles() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const [searchParams] = useSearchParams();
	const returnUrl = encodeURIComponent(searchParams.get("returnUrl") ?? "");
	const navigate = useNavigate();
	const location = useLocation();

	const approveQuality = useApproveQuality(
		order.details.retailOrderID,
		(result) => {
			showSuccessMessage("Quality has been approved");

			const newActionRequiredID = result.activeARs.find(x => x == 145);
			const to = `/cfi/retail-order/${order.details.retailOrderID}/${newActionRequiredID}` +
				(!!returnUrl ? '?returnUrl=' + returnUrl : '');

			if (newActionRequiredID && location.pathname !== to) {
				navigate(to);
			}
			else {
				refetchOrder();
			}
		},
		(error) => showErrorMessage(error)
	);

	return (
		<>
			{
				order.details.activeARs.includes(AR.InstallerToVerifyCabinetQuality) &&
				<WorksheetTemplateLink
					worksheetType={WorksheetType.CabinetQualityCheck}
					caption="Download Cabinet Quality Check Worksheet Template"
				/>
			}
			<RetailOrderFiles
				fileTypes={[FileTypes.CabinetQualityCheckWorksheet]}
				defaultFileType={FileTypes.CabinetQualityCheckWorksheet}
				buttonCaption={order.details.activeARs.includes(AR.InstallerToVerifyCabinetQuality) ?
					'Upload Cabinet Quality Check' : undefined}
				onFileAdded={(fileType: FileTypes) => {
					if (fileType === FileTypes.CabinetQualityCheckWorksheet) {
						confirm("Do you want to approve quality?", "Approve Quality")
							.then((result) => {
								if (result) {
									approveQuality.mutate();
								}
							});
					}
				}}
			/>
		</>
	)
}
